module.exports = __webpack_public_path__ + "img/GPI_logo.f4470a70.jpg";